import React from 'react';
import style from './recipe.module.css';

const Recipe = ({title,calories,image,ingredients}) =>{
    return(
        <div className={style.recipe}>
            <h1 className={style.heading}>{title}</h1>
            <p>{calories}&ensp;calories</p>
            <img className={style.image} src={image} alt=""/>
            <ol>
                {ingredients.map(ingredient =>(
                <li>{ingredient.text}</li>
                ))}
            </ol>
        </div>
    )
}

export default Recipe;